import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import Sidebar from '../navigation/Sidebar';
import Rest from "../../services/Rest";
import SweetAlert from 'react-bootstrap-sweetalert';
const initialState = {
    servidores: [],
    sinServidores: false,
    error: false,
    messageError: "",
    success: false,
    messageSuccess: "",
    showSweet: false,
    id_eliminar: 0
}
class Servers extends Component {

    constructor(props) {
        super(props);
        this.Rest = new Rest();

        this.datauser = JSON.parse(localStorage.getItem("ls")) || [];
    }

    state = { ...initialState }

    componentDidMount() {
        this.obtenerServidores();

    }

    obtenerServidores() {
        this.Rest.get("servidores", this.datauser)
            .then(response => {
                if (response.status === 200) {
                    this.setState({
                        servidores: response.data
                    })
                }
                else {
                    if (response.status === 404) {
                        localStorage.removeItem('ls');
                        window.location = window.location.origin;
                    }
                    else {
                        this.setState({
                            error: true,
                            messageError: response.message
                        })
                    }
                }
            })
            .catch(err => {
                this.setState({ 
                    error: true,
                    messageError: "Error de respuesta del servidor de sms rápidos"
                })
            })
    }


    eliminarServidor() {
        const idServidor = this.state.id_eliminar;
        const servidores = [...this.state.servidores];
        this.Rest.delete("servidores/" + idServidor, this.datauser)
            .then(response => {
                if (response.status === 200) {
                    const _servidores = servidores.filter(serv => serv.id_servidor !== idServidor);
                    this.setState({
                        servidores: _servidores
                    })
                    this.setState({
                        success: true,
                        messageSuccess: "Servidor eliminado.",
                        showSweet: false,
                        id_eliminar: 0
                    })
                }
                else {
                    if (response.status === 404) {
                        localStorage.removeItem('ls');
                        window.location = window.location.origin;
                    }
                    else {
                        this.setState({
                            error: true,
                            messageError: response.message,
                            showSweet: false,
                            id_eliminar: 0
                        })
                    }
                }
            })
            .catch(err => {
                this.setState({
                    error: true,
                    messageError: "Error de respuesta del servidor",
                    showSweet: false,
                    id_eliminar: 0
                })

            })
    }

    editarServidor(id) {
        this.props.history.push("/editar-servidor/" + id)
    }

    detalleServidor(id) {
        this.props.history.push("/detalle-servidor/" + id)
    }

    dismiss() {
        this.setState({
            error: false,
            success: false,
            messageError: "",
            messageSuccess: ""
        })
    }

    showSweet(id) {
        this.setState({
            showSweet: true,
            id_eliminar: id
        })
    }

    handleCheck = e => {
        e.persist();
        this.Rest.post(this.state.servidores[e.target.dataset.id], 'estado_servidor', 'estatus', this.datauser)
            .then(resp => {
                if (resp.status === 200) {
                    this.setState({
                        error: false,
                        messageError: ""
                    }, () => {
                        let servidores = [...this.state.servidores]
                        servidores[e.target.dataset.id]['estado'] = resp.data.estado
                        this.setState({
                            servidores
                        })
                    })
                }
                else {
                    if (resp.status === 404) {
                        localStorage.removeItem('ls');
                        window.location = window.location.origin;
                    }
                    else {
                        this.setState({
                            error: true,
                            messageError: resp.message
                        })
                    }
                }
            })
            .catch(err => {
                this.setState({
                    error: true,
                    messageError: "Error de respuesta del servidor."
                })
            })
    }

    render() {
        const { sinServidores, error, messageError, messageSuccess, success } = this.state;
        return (
            <Fragment>

                <div className="wrapper">
                    <Sidebar logout={() => this.props.callBackLogout()} />
                    <div id="content">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="dashboard-panel">
                                        <h4 className="mb-center">Listado de servidores</h4>

                                        <div className="container">
                                            <div className="row">
                                                {sinServidores ?
                                                    <div className="col-md-12">
                                                        <div className="alert alert-info">Sin servidores</div>
                                                    </div>
                                                    :
                                                    this.state.servidores.map((servidor, index) => (
                                                        <div className="col-md-4 border-box" key={index}>
                                                            <div className="server-container">
                                                                <h4 className="mb-center">Servidor: {servidor.nombre}</h4>
                                                                <div className="list-inline">
                                                                    <div className="list-inline-item">Estado: </div>
                                                                    <div className="list-inline-item">
                                                                        <div className="list-inline-item">

                                                                            <div className="custom-control custom-switch">
                                                                                <input
                                                                                    type="checkbox"
                                                                                    className="custom-control-input"
                                                                                    id={"estado" + index}
                                                                                    name={"estado" + index}
                                                                                    data-id={index}
                                                                                    value={this.state.servidores[index].estado}
                                                                                    onChange={this.handleCheck}
                                                                                    defaultChecked={servidor.estado === "1" ? "checked" : ""} />
                                                                                <label className="custom-control-label" htmlFor={"estado" + index}> Habilitar/Deshabilitar servidor</label>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <ul className="button-container">
                                                                <li>
                                                                    <button className="btn btn-secondary btn-sm" onClick={() => this.detalleServidor(servidor.id_servidor)}><i className="fas fa-list"></i> Detalle</button>
                                                                </li>
                                                                <li>
                                                                    <button onClick={() => this.editarServidor(servidor.id_servidor)} type="button" className="btn btn-primary btn-sm">
                                                                        <i className="fas fa-pencil-alt"></i> Editar
                                                                </button>
                                                                </li>
                                                                <li>
                                                                    <button className="btn btn-danger btn-sm" onClick={() => this.showSweet(servidor.id_servidor)}>
                                                                        <i className="fas fa-times"></i> Eliminar
                                                                </button>
                                                                </li>
                                                            </ul>

                                                        </div>
                                                    ))

                                                }
                                            </div>
                                        </div>
                                        {error ?
                                            <div className="alert alert-danger alert-float">
                                                <button type="button" className="close" onClick={() => this.dismiss()}>
                                                    <span aria-hidden="true">&times;</span>
                                                </button><b>{messageError}</b></div> : null}
                                        {success ?
                                            <div className="alert alert-success alert-float">
                                                <button type="button" className="close" onClick={() => this.dismiss()}>
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                                <b>{messageSuccess}</b>
                                            </div> : null}
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>


                <SweetAlert
                    warning
                    showCancel
                    confirmBtnText="Sí"
                    confirmBtnBsStyle="danger"
                    cancelBtnText="Cancelar"
                    cancelBtnBsStyle="primary"
                    show={this.state.showSweet}
                    title="¿Realmente deseas eliminar este servidor?"
                    onCancel={() => this.setState({ showSweet: false })}
                    onConfirm={() => {
                        this.eliminarServidor();
                    }}
                />


            </Fragment>
        );
    }
}

export default withRouter(Servers);



// WEBPACK FOOTER //
// ./src/components/servers/Servers.js